import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import store from 'src/store';
import {
  shouldPinEncounter,
  listEncounters,
} from 'src/modules/ambient_solo/store/actions/encounter';
import { addPinnedEncounter } from 'src/modules/ambient_solo/store/slices/encounter';

export * from './useGetEncounterList';
export * from './useGetEncounterDetails';
export * from './useStartEncounter';
export * from './useGetEncounterDocumentList';
export * from './useLinkEncounterDocuments';
export * from './useUpdateEncounterDetails';
export * from './useTagEncounter';

export const useLegacyEncounterStore = () => {
  const dispatch = useDispatch();

  const updateEncounterList = useCallback(
    async (
      legacySearchFilters: unknown,
      { currentEncounterId }: { currentEncounterId: string }
    ) => {
      if (shouldPinEncounter(legacySearchFilters)) {
        const pinnedEncounterIds: string[] =
          store.getState().encounterState.pinnedEncounterIds || [];
        if (!pinnedEncounterIds.includes(currentEncounterId)) {
          dispatch(addPinnedEncounter(currentEncounterId));
        }
      }

      await dispatch(listEncounters(legacySearchFilters) as any);
    },
    [dispatch]
  );

  return { updateEncounterList };
};
